import { $axios, setBaseUrl, setHeader, setToken } from '@/plugins/axios';
import type { CheckUserDTO, CheckUserProfileResponse, CognitoProviderDTO } from '@/types/Auth';
import type { IFederatedToken, IUserExists } from '@/interfaces/IUser';
import { useAuthStore } from '@/stores/auth';
import { API_BASE_URL, AWS_COGNITO_DOMAIN } from '@/utils/constants';

const auth = () => ({
  seedUser() {
    const { accessToken } = useAuthStore();
    setHeader($axios, 'Content-Type', 'application/json');
    setBaseUrl($axios, API_BASE_URL);
    setToken($axios, accessToken, 'Bearer');

    return $axios.post(`seed-user-profile`);
  },

  cognitoGetToken(data: CognitoProviderDTO) {
    setHeader($axios, 'Content-Type', 'application/x-www-form-urlencoded');
    setBaseUrl($axios, `${AWS_COGNITO_DOMAIN}/oauth2`);

    return $axios.post<CognitoProviderDTO, IFederatedToken>(`/token`, data);
  },

  /**
   * Checks if a user email already exists in the system.
   * @param email - The email address to check.
   * @returns Promise resolving to { exists: boolean }
   */
  checkUserExist(email: string): Promise<IUserExists> {
    setHeader($axios, 'Content-Type', 'application/json');
    setBaseUrl($axios, API_BASE_URL);

    return $axios.post<CheckUserDTO, IUserExists>('check-user', { email });
  },

  /**
   * Checks if a user profile already exists in the system to .
   * @param idToken - The idToken from federated login to check.
   * @returns Promise resolving to CheckUserProfileResponse type
   */
  checkUserProfileExist(idToken: string): Promise<CheckUserProfileResponse> {
    const { federatedAccessToken } = useAuthStore();
    setHeader($axios, 'Content-Type', 'application/json');
    setBaseUrl($axios, API_BASE_URL);
    setToken($axios, federatedAccessToken, 'Bearer');

    return $axios.post<CheckUserDTO, CheckUserProfileResponse>('check-user-profile', { idToken });
  },
});

export const { seedUser, cognitoGetToken, checkUserExist, checkUserProfileExist } = auth();
